import { render, staticRenderFns } from "./MembersCard.vue?vue&type=template&id=37a3f53e"
import script from "./MembersCard.vue?vue&type=script&lang=js"
export * from "./MembersCard.vue?vue&type=script&lang=js"
import style0 from "./MembersCard.vue?vue&type=style&index=0&id=37a3f53e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports